import { call, put, getContext } from 'redux-saga/effects'
import RehydrateStore from 'APP/Store/RehydrateStore'
import { retrieveLoginData } from 'APP/Sagas/AuthSagas'
import { initConfig } from 'APP/Lib/Initializers'
import { initializationActions } from './slice'
import type { SagaContext } from './types'

/**
 * Runs immediately when JS context starts.
 * Only add code here that can run headlessly (no UI, no navigation).
 */
export function* initialize() {
  const store: SagaContext['store'] = yield getContext('store')
  yield call(RehydrateStore.hydrate, store)
  yield call(retrieveLoginData)
  yield call(initConfig)
  // All initialization logic must complete before this line, as it signals the app is initialized.
  yield put(initializationActions.setInitialized())
}
